import React from "react";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import PropTypes from "prop-types";
import { CategoryCard } from "./CategoryCard";
import { Result } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import { useHorizontalBoardActions } from "./hooks/useHorizontalBoardActions";

export const HorizontalBoard = ({
	initialData = [],
	selectedItems = {},
	showArchived = false,
	onUpdateOrder = () => {},
	onDeleteClassifications = () => {},
	onEditClassifications = () => {},
	onToggleSelection = () => {},
	onSelectWithChildren = () => {},
}) => {
	const {
		categories,
		handleDragEnd,
		handleAddSubCategory,
		addClassificationToNode,
		renameClassificationNode,
		handleDeleteNode,
	} = useHorizontalBoardActions(
		initialData,
		showArchived,
		onUpdateOrder,
		onDeleteClassifications,
		onEditClassifications,
	);

	return (
		<div style={{ overflowX: "auto", padding: 16, whiteSpace: "nowrap" }}>
			{categories.length === 0 && (
				<Result
					icon={<SmileOutlined />}
					title="Esta vacío"
					subTitle="No hay clasificaciones disponibles. Por favor, añade una nueva categoría para que puedas verificar tus transacciones bancarias."
				/>
			)}

			<DragDropContext onDragEnd={handleDragEnd}>
				<Droppable
					droppableId="categories"
					direction="horizontal"
					type="CATEGORY"
				>
					{(provided) => (
						<div
							ref={provided.innerRef}
							{...provided.droppableProps}
							style={{
								display: "flex",
								gap: 26,
								minHeight: 200,
								paddingBottom: 20,
								position: "relative",
								flexWrap: "nowrap",
								overflowX: "auto",
								minWidth: "fit-content",
							}}
						>
							{categories.map((cat, index) => (
								<Draggable
									key={cat.id}
									draggableId={cat.id}
									index={index}
									isDragDisabled={cat.archived && !showArchived}
								>
									{(provided, snapshot) => (
										<CategoryCard
											cat={cat}
											index={index}
											provided={provided}
											snapshot={snapshot}
											onHandleAddSubCategory={handleAddSubCategory}
											onHandleAddClassification={addClassificationToNode}
											onRenameNode={renameClassificationNode}
											onHandleDelete={handleDeleteNode}
											isSelected={selectedItems[cat.id] || false}
											onToggleSelection={onToggleSelection}
											onSelectWithChildren={onSelectWithChildren}
											showArchived={showArchived}
											selectedItems={selectedItems}
										/>
									)}
								</Draggable>
							))}
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>
		</div>
	);
};

HorizontalBoard.propTypes = {
	initialData: PropTypes.array.isRequired,
	selectedItems: PropTypes.object,
	showArchived: PropTypes.bool,
	backupData: PropTypes.array,
	onUpdateOrder: PropTypes.func.isRequired,
	onDeleteClassifications: PropTypes.func,
	onAddClassification: PropTypes.func,
	onEditClassifications: PropTypes.func,
	onToggleSelection: PropTypes.func,
	onSelectWithChildren: PropTypes.func,
};
